export default {
  "Abertura de filial": 1,
  "Troca de local da sede": 2,
  "Troca de garantia": 3,
  "Locação para moradia": 4
};
